export const iconFontAwesomeMapsTree = (
	<i className="fa-solid fa-tree"></i>
);
